import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import PlainIDLangChainDemo from './PlainIDLangChainDemo';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PlainIDLangChainDemo />
  </React.StrictMode>
);
